import React, { useContext } from 'react';
import { DetailsContext } from '@/common/containers/TaskDetails/components/DetailsProvider';
import styles from '@/common/containers/TaskDetails/styles.less';
import EditIcon from '@mui/icons-material/Edit';
import cx from 'classnames';
import { formatDisplayDate, ReactBB } from '@/common/utils/index';
import { useLocale } from '@/common/hooks/index';
import { isSaleProceedsField } from '@/common/containers/Forms/final-disposition.utils';

const FinalDispositionDetails = ({ taskUid }) => {
  const { finalDisposition, openFinalDisposition } =
    useContext(DetailsContext);
  const { isFr } = useLocale();
  if (!finalDisposition || finalDisposition.answers.length === 0) return null;

  const { answers, question } = finalDisposition;
  const answer = answers[0].value;
  return (
    <div className={styles.infoBlock}>
      <div className={styles.infoBlockHeader}>
        <h5 className={styles.infoBlockHeaderTitle}>
          Final disposition details
        </h5>
        <div
          className={styles.additionalInfo}
          onClick={() =>
            openFinalDisposition({
              hideSaleProceeds: taskUid === 'CL06',
            })
          }
        >
          <EditIcon />
          Edit
        </div>
      </div>
      <div className={cx(styles.infoBlockBody, styles.finalDesp)}>
        <div className={styles.finalDespLabel}>{`${
          answer.finalDisp
        } on ${formatDisplayDate(answer.dispDate, isFr ? 'fr' : 'en')}`}</div>
        {question.properties
          .filter(
            (property) =>
              !['finalDisp', 'dispDate'].includes(property.key) &&
              !(taskUid === 'CL06' && isSaleProceedsField(property))
          )
          .map(({ key, label }) => {
            const res = answer[key];
            return (
              <div key={label} className={styles.finalDespItem}>
                <span className={styles.finalDespItemTitle}>
                  {ReactBB(label)}
                </span>
                <span
                  className={cx(styles.finalDespItemText, !res && 'textError')}
                >
                  {res || 'no data entered'}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default FinalDispositionDetails;
